import { baseurl } from '../../BaseUrl'
import axios from 'axios'


export const updateRestaurantApi = async(id,data)=>{

    try{
        const res =  await axios.put(`${baseurl}/edit-restaurant/${id}`,data) ;
        return { isError: false, data: res.data }
    }catch(e){
        return { isError: true, data: e.response.data.message }

    }
}